import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { leaveOverviewConstants } from "../constant/leaveOverview.constants";
import { leaveOverview } from "../services/leaveOverview.service";

const _errorCode = CONSTANT.errorCode;
const emptyDataCode = CONSTANT.messageCode.emptyData;

export const getLeaveOverview = (data, isSearch = false, isPaging = false) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        isPaging && dispatch(paging());
        isSearch && dispatch(searching());
        leaveOverview.getListOverview(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (res.error_code === emptyDataCode) {
                        dispatch(success([]));
                    }
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(list) {
        return { type: leaveOverviewConstants.GET_OVERVIEW_LIST_SUCCESS, list };
    }
    function searching() {
        return { type: leaveOverviewConstants.GET_OVERVIEW_LIST };
    }
    function paging() {
        return { type: leaveOverviewConstants.GET_OVERVIEW_LIST_PAGE };
    }
};

export const updateLeaveOverview = (data, successParams = null) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(updating());
        leaveOverview.updateOverview(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (successParams) {
                        leaveOverview.getListOverview(successParams).then((res) => {
                            if (!res) return;
                            switch (res["http_code"]) {
                                case _errorCode.APISuccess:
                                    if (res.error_code === emptyDataCode) {
                                        dispatch(success([]));
                                    } else dispatch(success(res.result));
                                    break;
                                case _errorCode.TOKENExpired:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.APIInvalids:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.ClientNotPermission:
                                    functionCommon.logout();
                                    break;

                                default:
                                    window.location = "/error/404";
                                    break;
                            }
                        });
                    }
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    break;
            }
        });
    };

    function success(newList) {
        return { type: leaveOverviewConstants.UPDATE_OVERVIEW_SUCCESS, newList };
    }
    function updating() {
        return { type: leaveOverviewConstants.UPDATE_OVERVIEW };
    }
    function failure(error) {
        return { type: leaveOverviewConstants.UPDATE_OVERVIEW_FAIL, error };
    }
};

export const clearMessageLeaveOverview = () => {
    return (dispatch) => {
        dispatch({ type: leaveOverviewConstants.CLEAR_MESSAGE });
    };
};
